import type CondicaoPagamentoParcela from "./CondicaoPagamentoParcela";

export default class CondicaoPagamento {
    id: number | null;
    ativa: boolean;
    codigoInterno: string;
    descricao: string;
    abreviatura: string | null;
    parcelas: CondicaoPagamentoParcela[];

    constructor(
        id: number | null = null,
        ativa = true,
        codigoInterno = '',
        descricao = '',
        abreviatura: string | null = null,
        parcelas: CondicaoPagamentoParcela[] = []
    ) {
        this.id = id;
        this.ativa = ativa;
        this.codigoInterno = codigoInterno;
        this.descricao = descricao;
        this.abreviatura = abreviatura;
        this.parcelas = parcelas;
    }
}
